import { render, staticRenderFns } from "./BlitzVideo.vue?vue&type=template&id=4ff7fcc6&scoped=true&"
import script from "./BlitzVideo.vue?vue&type=script&lang=js&"
export * from "./BlitzVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff7fcc6",
  null
  
)

export default component.exports